import { DefaultState } from '@src/redux/types'

import { CHAT_MESSAGE_ALL, CHAT_MESSAGE_LIST, CHAT_MESSAGE_POST } from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ data: null, loading: false, error: null })

export const initialState: () => {
  [CHAT_MESSAGE_ALL]: DefaultState<`${typeof API.CHAT_MESSAGE_ALL}`, 'get'>
  [CHAT_MESSAGE_LIST]: DefaultState<`${typeof API.CHAT_MESSAGE}`, 'get'>
  [CHAT_MESSAGE_POST]: DefaultState<`${typeof API.CHAT_MESSAGE}`, 'post'>
} = () => ({
  [CHAT_MESSAGE_ALL]: defaultState(),
  [CHAT_MESSAGE_LIST]: defaultState(),
  [CHAT_MESSAGE_POST]: defaultState(),
})
